import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'rentInput',
    'rentSlider',
    'gliCheckbox',
    'gliRow',
    'managementFeeOutput',
    'gliFeeOutput',
    'monthlyFeeOutput',
    'annualFeeOutput'
  ];

  connect() {
    this.rent = this.formatNumber(this.rentInputTarget.value) || 1500;
    this.updateGliRowsVisibility();
    this.calculate();
  }

  updateRent(event) {
    const { name, value } = event.target;
    this.rent = this.formatNumber(value);

    if (name === 'rentSlider') {
      this.rentInputTarget.value = this.rent.toLocaleString('fr-FR');
    } else {
      this.rentSliderTarget.value = this.rent;
    }

    this.calculate();
  }

  toggleGli() {
    this.updateGliRowsVisibility();
    this.calculate();
  }

  updateGliRowsVisibility() {
    this.gliRowTargets.forEach(row => row.classList.toggle('hidden', !this.gliCheckboxTarget.checked));
  }

  calculate() {
    const withGli = this.gliCheckboxTarget.checked;
    const managementFee = Math.max(39, Math.round(this.rent * 0.049));
    const gliFee = withGli ? Math.round(this.rent * 0.025) : 0;
    const monthlyFee = managementFee + gliFee;
    const annualFee = monthlyFee * 12;

    this.managementFeeOutputTarget.innerText = `${managementFee.toLocaleString('fr-FR')} €`;
    this.gliFeeOutputTarget.innerText = `${gliFee.toLocaleString('fr-FR')} €`;
    this.monthlyFeeOutputTarget.innerText = `${monthlyFee.toLocaleString('fr-FR')} €`;
    this.annualFeeOutputTarget.innerText = `${annualFee.toLocaleString('fr-FR')} €`;
  }

  formatNumber(value) {
    const number = parseFloat(value.toString().replace(/\s+/g, '').replace(/\D/g, ''));

    return isNaN(number) ? 0 : number;
  }
}
